import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { SolutionMap } from './components/SolutionMap';
import { Transformation } from './components/Transformation';
import { WhatIncludes } from './components/WhatIncludes';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-cream text-navy font-sans selection:bg-terracotta/30" data-id="element-0">
      <Hero data-id="element-1" />
      <PainSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedSolutions data-id="element-4" />
      <SolutionMap data-id="element-5" />
      <Transformation data-id="element-6" />
      <WhatIncludes data-id="element-7" />
      <FinalCTA data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}